"use client";

import React from 'react';
import { motion } from 'framer-motion';
import { Check, UserCircle2, Star, FileText, BriefcaseBusiness } from 'lucide-react';
import { cn } from '@/lib/utils';

const steps = [
  {
    id: 1,
    title: "Registrieren",
    description: "Erstelle kostenlos und unverbindlich dein persönliches Profil mit nur wenigen Klicks.",
    icon: UserCircle2
  },
  {
    id: 2,
    title: "Profil vervollständigen",
    description: "Ergänze Informationen zu deinen Fähigkeiten, Qualifikationen und Karrierewünschen.",
    icon: FileText
  },
  {
    id: 3,
    title: "KI-Optimierung",
    description: "Unsere KI analysiert dein Profil und hilft dir bei der Optimierung für potenzielle Arbeitgeber.",
    icon: Star
  },
  {
    id: 4,
    title: "Interview-Vorbereitung",
    description: "Bereite dich optimal mit unseren KI-Tools auf Vorstellungsgespräche vor.",
    icon: BriefcaseBusiness
  },
  {
    id: 5,
    title: "Erfolgreiche Vermittlung",
    description: "Überzeuge durch perfekte Vorbereitung und sichere dir deinen Traumjob.",
    icon: Check
  }
];

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6 }
  }
};

export function CandidateProcess() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
          className="text-center mb-16"
        >
          <h2 className="text-h2 mb-2">So funktioniert es</h2>
          <p className="text-body-lg max-w-2xl mx-auto">
            In nur wenigen Schritten zu deinem Traumjob – transparent, einfach und unterstützt durch modernste KI-Technologie
          </p>
          <div className="w-24 h-1 mx-auto mt-4 rounded-full bg-true-blue" />
        </motion.div>

        <div className="max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <motion.div
              key={step.id}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
              custom={index}
              className="mb-12 relative"
            >
              <div className={cn(
                "flex items-start",
                "md:ml-8 pl-8",
                "relative z-10"
              )}>
                {/* Number Circle */}
                <div className={cn(
                  "absolute -left-4 -mt-2",
                  "flex items-center justify-center",
                  "w-8 h-8 rounded-full",
                  "bg-true-blue text-white font-bold"
                )}>
                  {step.id}
                </div>
                
                {/* Content */}
                <div className="bg-floral-white-50 p-6 rounded-lg shadow-sm border border-true-blue/10 w-full">
                  <div className="flex items-center mb-3">
                    <step.icon className="w-6 h-6 text-true-blue mr-3" />
                    <h3 className="font-gilroy font-bold text-lg">{step.title}</h3>
                  </div>
                  <p className="text-foreground/80">{step.description}</p>
                </div>
              </div>
              
              {/* Connecting Line */}
              {index < steps.length - 1 && (
                <div className="absolute h-12 w-0.5 bg-true-blue/30 left-0 top-full ml-0 -mt-4 md:ml-8" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}